import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/categories';

export default function FaqSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Frequently Asked Questions About Sugargoo Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
            Quick answers to the most common questions about Sugargoo and the spreadsheet resource.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200"
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-150 list-none">
                <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h4>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 group-open:bg-accent-100 flex items-center justify-center transition-colors duration-200">
                  <i className="ri-arrow-down-s-line text-secondary-500 group-open:text-accent-600 text-sm transition-transform duration-200 group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/sugargoo-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-accent-300 text-accent-700 rounded-full text-sm font-medium hover:bg-accent-50 transition-all duration-200 whitespace-nowrap"
          >
            Read the Detailed Sugargoo Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}